import UserManagement from './userManagement'

export default UserManagement;
